import {
  MilestoneFields,
  MilestoneTypeEnum
} from '@/types/graphql/schemaTypes';
import i18n from '@/plugins/i18n';

export const getMilestoneType = (milestone: MilestoneFields) => {
  if (milestone.milestoneType === MilestoneTypeEnum.free_text) {
    return milestone.details.eventInfo
      ? milestone.details.eventInfo
      : i18n.t(`milestoneType.${milestone.milestoneType}`).toString();
  }
  return i18n.t(`milestoneType.${milestone.milestoneType}`).toString();
};

export function statusColor(shipmentStatus) {
  const fontBlackStatuses = [
    'shipment_arrived',
    'shipment_completed',
    'shipment_cancelled'
  ];
  if (fontBlackStatuses.includes(shipmentStatus.status)) {
    return 'text-black';
  } else {
    return shipmentStatus.isProblem ? 'text-red-500' : 'text-blue-500';
  }
}
